import { keyframes } from '@emotion/react';

// ── Layout dimensions ──────────────────────────────────────────────
export const MOBILE_POPOVER_BREAKPOINT = 650;

export const INLINE_WIDTH = 217;
export const INLINE_WIDTH_MEDIUM = 160;
export const INLINE_WIDTH_SMALL = 120;

export const POPOVER_WIDTH = 96;
export const POPOVER_HEIGHT = 30;

export const COMPACT_BUTTON_WIDTH = 36;
export const COMPACT_BUTTON_HEIGHT = 24;

// ── Transitions ────────────────────────────────────────────────────
export const IDLE_TRANSITION = 'max-width 200ms cubic-bezier(0.4, 0, 0.2, 1)';
export const CLOSING_TRANSITION = 'max-width 160ms cubic-bezier(0.4, 0, 0.2, 1), opacity 160ms ease';

// ── Keyframes ──────────────────────────────────────────────────────
export const expandBar = (to: number) => keyframes`
  from { max-width: 32px; }
  to { max-width: ${to}px; }
`;
